import { SceneDef } from './SceneDef';
import { TextPanelDef } from './TextPanelDef';
// type TextWithoutVal = Omit<TextPanelDef, 'value'>;
export class PointDateDef extends TextPanelDef {
  pointWDGroupId: string;
  dateFormat = 'EEEEE';
  relativeFormat = false;
  elementType: keyof SceneDef = 'pointDates';
}
